import { useQuery } from 'react-query';

import {
  FilterOptionsParams,
  FilterOptionsResponse,
  getDirectoryFilterOptions,
} from '../utils/backend-api/subscriber_directory';

export const DIRECTORY_FILTER_OPTIONS_KEY = 'DIRECTORY_FILTER_OPTIONS_KEY';

export default function useDirectoryFilterOptions(sanitizedParams: FilterOptionsParams) {
  const { data: filterOptions, isLoading: areFilterOptionsLoading } =
    useQuery<FilterOptionsResponse>(
      DIRECTORY_FILTER_OPTIONS_KEY,
      async () => await getDirectoryFilterOptions(sanitizedParams)
    );

  return { filterOptions, areFilterOptionsLoading };
}
